// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  IBranchGetListAttrs,
  IBranchGetDetailAttrs,
  IBranchSaveAttrs,
  IBranchGetDropdownAttrs,
} from 'interfaces/back-office/master/branch/branch-view.interface'

const useMasterBranch = () => {
  const {
    masterBranch: {
      masterBranch_loading,
      masterBranch_dropdown,
      masterBranch_list,
      masterBranch_detail,
      masterBranch_CLEAR_LIST,
      masterBranch_CLEAR_DETAIL,
      masterBranch_CLEAR_DROPDOWN,
      masterBranch_fetchList: fetchList,
      masterBranch_fetchDetail: fetchDetail,
      masterBranch_save: save,
      masterBranch_fetchDropdown: fetchDropdown,
    },
  } = useStores()

  /**
   * @description Get branch list
   *
   * @param {IBranchGetListAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterBranch_fetchList = useCallback(
    async (payload: IBranchGetListAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchList({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchList],
  )

  /**
   * @description Get branch detail
   *
   * @param {IBranchGetDetailAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterBranch_fetchDetail = useCallback(
    async (payload: IBranchGetDetailAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDetail({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDetail],
  )

  /**
   * @description Save branch
   *
   * @param {IBranchSaveAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterBranch_save = useCallback(
    async (payload: IBranchSaveAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        save({
          params: { ...payload.params },
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [save],
  )

  /**
   * @description Get branch dropdown
   *
   * @param {IBranchGetDropdownAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterBranch_fetchDropdown = useCallback(
    async (payload: IBranchGetDropdownAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDropdown({
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDropdown],
  )

  return {
    masterBranch_loading,
    masterBranch_list,
    masterBranch_detail,
    masterBranch_dropdown,
    masterBranch_CLEAR_LIST,
    masterBranch_CLEAR_DETAIL,
    masterBranch_CLEAR_DROPDOWN,
    masterBranch_fetchList,
    masterBranch_fetchDetail,
    masterBranch_fetchDropdown,
    masterBranch_save,
  }
}

export { useMasterBranch }
